import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Bookmark = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1 1.491C7.1.9 7.58.42 8.17.42h27.657C36.42.42 36.9.9 36.9 1.49V43.35a1.071 1.071 0 0 1-1.688.876L22 34.944 8.787 44.225a1.071 1.071 0 0 1-1.687-.877V1.492Zm2.142 1.072v38.724l12.142-8.53c.37-.26.862-.26 1.232 0l12.14 8.53V2.563H9.243Z"
  }));
});
Bookmark.displayName = 'Bookmark';
Bookmark.defaultProps = {
  'aria-label': 'Bookmark'
};
export default Bookmark;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Bookmark.js
// module id = 3728
// module chunks = 11